var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"social"},_vm._l((_vm.links),function(link){return _c('a',{key:link.icon,class:'social__link social__link--' + link.icon,attrs:{"target":"_blank","href":link.link}},[_c('z-icon',{attrs:{"name":(link.dir ? link.dir : 'social/') + link.icon,"width":"100%","height":"100%"}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }